@if (customer) {
    <div [class.d-none]="!childActive" [class.detail-overlay]="!screenshot" [class.workarea]="childIsWorkarea">
        <router-outlet
            (activate)="childActivate(); childChanged($event)"
            (deactivate)="childDeactivate()"></router-outlet>
    </div>
}
@if (!hideMap && customer && (!childActive || !screenshot) && customer.id > 0) {
    <app-workareas-map [class.d-none]="childActive"></app-workareas-map>
}
